<div 
    #container
    [ngClass]="{
        'refueling': eventMode === EVENT_TYPE_ENUM.Fuel && eventType === VALUE_SIGN.EventFuelRefuelling,
        'fuel-loss': eventMode === EVENT_TYPE_ENUM.Fuel && eventType === VALUE_SIGN.EventFuelLoss,
        'alarm': eventMode === EVENT_TYPE_ENUM.Alarm,
        'area': eventMode === EVENT_TYPE_ENUM.Area && (eventType === VALUE_SIGN.EventAreaEnter || eventType === VALUE_SIGN.EventAreaExit)
    }"
    class="container-park"
>
    <div class="container-park__status">
        <ng-container *ngIf="eventMode === EVENT_TYPE_ENUM.Fuel && (eventType === VALUE_SIGN.EventFuelRefuelling || eventType === VALUE_SIGN.EventFuelLoss)">
            <img class="fuel-icon" src="/assets/img/fuel-icon-station.svg">
            <span>
                {{ eventType === VALUE_SIGN.EventFuelRefuelling ? ('fuel-status.refueling'|translate) : ('fuel-status.loss'|translate) }}
            </span>
        </ng-container>
        <span *ngIf="eventMode === EVENT_TYPE_ENUM.Alarm">
            ! &nbsp; {{ 'events-list.alarm'|translate }}
        </span>
        <ng-container *ngIf="eventMode === EVENT_TYPE_ENUM.Area && (eventType === VALUE_SIGN.EventAreaEnter || eventType === VALUE_SIGN.EventAreaExit)">
            <img class="fuel-icon" src="/assets/img/enter-area.svg">
            <span>
                {{ eventType === VALUE_SIGN.EventAreaExit ? ('area-event-type.leaves'|translate) : ('area-event-type.entry'|translate) }}
            </span>
        </ng-container>
    </div>
    <button (click)="onClickHideModal()" class="close">
        <i class="pi pi-times"></i>
    </button>
    <div class="container-park__content">
        <span class="text date">
            {{ eventData?.TS | date: 'EEEE, d MMMM y HH:mm' : '' : langauge }}
        </span>
        <span class="text car">
            {{ vehicle?.Nm || defaultVehicleName }}
        </span>
        <span class="text driver-name">
            {{ driver?.FN || defaultDriverName }} {{ driver?.LN || '' }}
        </span>

        <div class="column-bottom">
            <div class="column-bottom__right">
                <!-- <span class="street">
                    PL, Strzałków, Kolejowa,9
                    <tk-vehicle-location [location]="eventData?.EL"></tk-vehicle-location>
                </span> -->
                <span *ngIf="eventMode === EVENT_TYPE_ENUM.Fuel && eventType === VALUE_SIGN.EventFuelRefuelling" class="fuel-info">
                    <img src="/assets/img/fuel-tank.svg" alt="">
                    {{'fuel-status.refueling'|translate}} + {{ valueLFuel | number:'1.0-0' }} L
                </span>
                <span *ngIf="eventMode === EVENT_TYPE_ENUM.Fuel && eventType === VALUE_SIGN.EventFuelLoss" class="fuel-info">
                    <img src="/assets/img/fuel-loss.svg" alt="fuel-loss">
                    {{'fuel-status.fuel-loss'|translate}} - {{ valueLFuel | number:'1.0-0' }} L
                </span>
                <span *ngIf="eventMode === EVENT_TYPE_ENUM.Alarm" class="alarm-info">{{ eventData.ED.Dc | translateByText }}</span>
                <span *ngIf="eventMode === EVENT_TYPE_ENUM.Area && eventType === VALUE_SIGN.EventAreaExit" class="area-info">{{'area-event-type.leaves'|translate}} {{eventData.ED.Nm || ('unkownArea'|translate)}}</span>
                <span *ngIf="eventMode === EVENT_TYPE_ENUM.Area && eventType === VALUE_SIGN.EventAreaEnter" class="area-info">{{'area-event-type.entry'|translate}} {{eventData.ED.Nm || ('unkownArea'|translate)}}</span>
            </div>

            <div class="column-bottom__actions">
                <a *ngIf="eventData" target="_blank" href="https://www.google.com/maps?t=k&q={{eventData.EL.Lt}}+{{eventData.EL.Ln}}" class="btn">
                    <img src="/assets/images/map/i-external-map-white.svg" alt="">
                </a>
                <button (click)="copyCords()" class="btn">
                    <img class="copy" src="/assets/images/shared/i-copy-black.svg" alt="">
                </button>
            </div>
        </div>
    </div>
</div>
